import { useCallback } from 'react'
import { t } from '@lingui/core/macro'
import { useQuery } from '@tanstack/react-query'
import { Select } from '@components/formFields/select'
import { getAccountUserList } from '@global/api'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { setTemplateDetails } from '../../template.actions'

const useAccountUserListQuery = () =>
  useQuery({
    queryKey: ['account-user-list'],
    queryFn: ({ signal }) => getAccountUserList({ signal }),
    refetchOnWindowFocus: false,
    select: data => data?.map(user => ({ id: user.id, name: user.name, email: user.email })),
  })

interface IUserRecipients {
  userId: string
  email: string
}

export const NotificationsSection = () => {
  const dispatch = useAppDispatch()
  const submissionStatusRecipients: IUserRecipients[] = useAppSelector(
    (state: any) => state.Template.template?.submissionStatusRecipients,
  )
  const { data = [], isLoading } = useAccountUserListQuery()

  const handleNotificationsChange = useCallback(
    (selected: (string | number)[]) => {
      const recipients: IUserRecipients[] = Object.values(
        data
          .filter(d => selected.includes(d.id))
          .map(m => ({ userId: String(m.id), email: m.email }))
          .reduce((acc, curr) => ({ ...acc, [curr.userId]: curr }), {}),
      )
      dispatch(setTemplateDetails({ submissionStatusRecipients: recipients }))
    },
    [data],
  )

  return (
    <>
      <h3 className="mb-[5px] text-[12px] text-cv-blue-400 font-bold">
        {t`Automatically submit inbound data`}
      </h3>
      <h2 className="mb-[10px] text-[23px] text-cv-blue-900 font-bold">{t`Notifications`}</h2>

      <Select
        name={t`Add users to recieve notifications of status updates`}
        popoverId="select-template"
        data={data}
        isLoading={isLoading}
        selectedItems={isLoading ? [] : submissionStatusRecipients?.map(d => +d.userId) || []}
        multi={true}
        onSelectCallback={handleNotificationsChange}
      >
        <Select.VirtualList>
          {(index, template) => (
            <Select.Option key={template.id} id={template.id} index={index} checkbox={true}>
              {template.name}
            </Select.Option>
          )}
        </Select.VirtualList>
      </Select>
    </>
  )
}
